import {
  LOAD_SHOPS,
  LOAD_CATEGORIES,
  SELECT_CATEGORY,
  SELECT_ONE_PRODUCT,
  CLEAR_ONE_PRODUCT,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  COUNT_DELIVERY_PRICE,
  CLEAR_CART,
  SHOW_CONTACT_POPUP,
  HIDE_CONTACT_POPUP,
  SEND_CONTACT_POPUP,
  BILLING_DETAILS,
  DELIVERY_DETAILS,
  CREATE_ORDER,
  CLEAR_DELIVERY_DATA
} from '../constants'

const captchaKey = window.getConfig.url;

export function loadShops(url_hash) {
  return {
    type: LOAD_SHOPS,
    payload: {url_hash},
    callAPI: captchaKey + '/get-shops'
  }
}

export function loadCategories(hashShop, shopAddress) {
  return {
    type: LOAD_CATEGORIES,
    payload: {hashShop, shopAddress},
    callAPI: captchaKey + `/get-categories?hash=${hashShop}`
  }
}

export function selectCategory(id) {
  return {
    type: SELECT_CATEGORY,
    payload: {id}
  }
}

export function selectOneProduct(id) {
  return {
    type: SELECT_ONE_PRODUCT,
    payload: {id}
  }
}

export function clearOneProduct() {
  return {
    type: CLEAR_ONE_PRODUCT
  }
}

export function addToCart(product) {
  return {
    type: ADD_TO_CART,
    payload: {product},
    generateId: true
  }
}

export function removeFromCart(idProduct) {
  return {
    type: REMOVE_FROM_CART,
    payload: {idProduct}
  }
}

export function clearCart() {
  return {
    type: CLEAR_CART
  }
}

export function countDeliveryPrice(hashShop, callApiData) {
  return {
    type: COUNT_DELIVERY_PRICE,
    callAPI: captchaKey + `/count-price?hash=${hashShop}`,
    isCallAPIData: true,
    callAPIData: callApiData,
    payload: callApiData
  }
}

export function showContactPopup() {
  return {
    type: SHOW_CONTACT_POPUP
  }
}

export function closeContactPopup() {
  return {
    type: HIDE_CONTACT_POPUP
  }
}

export function sendContactPopup(callApiData) {
  return {
    type: SEND_CONTACT_POPUP,
    callAPI: captchaKey + '/contact',
    isCallAPIData: true,
    callAPIData: callApiData
  }
}

export function getBillingDetails(data) {
  return {
    type: BILLING_DETAILS,
    payload: {data}
  }
}

export function getDeliveryDetails(dataDetails) {
  return {
    type: DELIVERY_DETAILS,
    payload: {dataDetails}
  }
}

export function createOrder(dataOrder, hashShop) {
  return {
    type: CREATE_ORDER,
    callAPI: captchaKey + `/create?hash=${hashShop}`,
    isCallAPIData: true,
    callAPIData: dataOrder
  }
}

export function clearDeliveryData() {
  return {
    type: CLEAR_DELIVERY_DATA
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/index.js